export const STATUS_IDS = {
    active: 1,
    noActive: 2,
}
